import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm, usePage } from '@inertiajs/vue3';
    import { OnboardingStep, SharedData } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import OnboardingStepForm from './OnboardingStepForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import { computed } from 'vue';
    import { Table } from '@tanstack/vue-table';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditOnboardingStep',
  props: {
    onboardingStep: {},
    table: {}
  },
  setup(__props: any) {

    const props = __props;

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        service: props.onboardingStep.service,
        other_title: props.onboardingStep.other_title,
        description: props.onboardingStep.description_translated,
        allow_comments: props.onboardingStep.allow_comments,
        allow_files: props.onboardingStep.allow_files,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.onboarding.update', { companyOnboardingStep: _ctx.onboardingStep.id }),
    method: "patch",
    "query-key": [_unref(QueryKey).ONBOARDING, selectedCompanyId.value],
    title: "onboarding.edit_step"
  }, {
    default: _withCtx(() => [
      _createVNode(OnboardingStepForm, {
        form: _unref(form),
        table: _ctx.table,
        "disable-service-change": true
      }, null, 8, ["form", "table"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})